module.exports = __webpack_public_path__ + "static/media/goto_recetario_mobile.9784eb41.svg";